import { FormInputProps } from '@usacsmideo/types';
import TextareaAutosize from 'react-textarea-autosize';

export const ScriptInput = (props: FormInputProps) => {
  return (
    <div className="my-2 flex w-full flex-col text-xl font-bold">
      <label>
        {props.label}
        <TextareaAutosize
          id={props.id}
          name={props.name}
          value={props.value}
          //@ts-expect-error - This is a valid event handler Tanstack Form doesn't let us customize the event type
          onChange={props.handleChange}
          autoComplete={props.autoComplete ? props.autoComplete : 'off'}
          placeholder={props.placeholder ? props.placeholder : ''}
          type={props.type ? props.type : 'text'}
          className="block min-h-80 min-w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
        />
      </label>
    </div>
  );
};
